export enum SubscriberScopeEnum {
    NP = 'np',
    USU = 'usu',
    NP_COSOUS = 'np_cosous',
    USU_COSOUS = 'usu_cosous',
}
